
import AcceptingOrderItemsTable from '../components/accepting_order_items/accepting_order_items_table.vue'
import AcceptingOrderItemsBooksTable from '../components/accepting_order_items/books_table.vue'

export default {
  components: {
    AcceptingOrderItemsTable,
    AcceptingOrderItemsBooksTable,
  },
  data: () => ({
  }),
  methods: {
  }
}
